import { Logger } from './logger'

/**
 * @param checkCondition Called to check if the callback should be called
 * @param callback Called when the checkCondition function returns true
 * @param timeout How long to wait between attempts
 * @param limit The amount of attempts to try before giving up
 * @param name A name for referencing later, if logs occur
 */
export const schedule = (
  checkCondition: () => boolean,
  callback: () => void,
  timeout: number,
  limit: number,
  name: string
) => {
  let attempts = 0
  const run = () => {
    attempts++
    if (checkCondition()) {
      callback()
    } else {
      if (attempts < limit) {
        setTimeout(run, timeout)
      } else {
        Logger.warn(
          `Failed to complete scheduled event ${name} after ${attempts} attempts.`
        )
      }
    }
  }
  run()
}
